/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
class SearchUIManager {
  resetUIState(stores) {
    if (stores.searchStore) {
      stores.searchStore.setShowNumberOfSearchResultsFound(false);
      stores.searchStore.setNumberOfSearchResultsInDocument(0);
      stores.searchStore.setPageBeingSearched(0);
      stores.searchStore.setShowSearchProgessBar(false);
      stores.searchStore.setIndexOfCurrentSearchResult(0);
    }
  }

  setProgressBarParameters(stores, pageBeingSearched, showProgressBar) {
    stores.searchStore.setPageBeingSearched(pageBeingSearched);
    stores.searchStore.setShowSearchProgessBar(showProgressBar);
  }

  setIndexOfCurrentSearchResult(stores, indexOfCurrentSearchResult) {
    stores.searchStore.setIndexOfCurrentSearchResult(indexOfCurrentSearchResult);
  }

  setNumberOfSearchResultsParameters(stores, showNumberOfSearchResultsFound, numberOfSearchResults) {
    stores.searchStore.setShowNumberOfSearchResultsFound(showNumberOfSearchResultsFound);
    stores.searchStore.setNumberOfSearchResultsInDocument(numberOfSearchResults);
  }
}

export { SearchUIManager };
